// Base Styles
import colors from "assets/mavric-theme/base/colors";
import borders from "assets/mavric-theme/base/borders";

const { primary, text } = colors;
const { borderRadius } = borders;

const textField = {
  styleOverrides: {
    root: {
      backgroundColor: primary.light,
      color: text.main,
      borderRadius: borderRadius.md,
    },
  },
};

export default textField;
